import imageField from 'molecules/Image/config';

import type { Input } from '@builder.io/sdk';

export const leaderShipCardFields = [
  imageField('image'),
  {
    name: 'carousel',
    type: 'object',
    subFields: [
      {
        name: 'videoFile',
        type: 'file',
        allowedFileTypes: ['.mp4'],
        helperText: 'Upload an MP4 file to be displayed in the carousel.',
      },
      imageField('mapImage'),
      {
        name: 'experience',
        type: 'string',
      },
    ],
  },
  {
    name: 'name',
    type: 'string',
  },
  {
    name: 'role',
    type: 'string',
  },
  {
    name: 'link',
    type: 'url',
  },
] as const satisfies DeepReadonly<Input[]>;

const leaderShipCardConfig = {
  name: 'Leadership Deck',
  inputs: leaderShipCardFields,
};

export type LeaderShipCardProps = GenerateBuilder<typeof leaderShipCardFields>;

export default leaderShipCardConfig;
